import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface TranslationToggleState {
    showKeys: boolean;
}

const initialState: TranslationToggleState = {
    showKeys: false,
};

export const translationToggleSlice = createSlice({
    name: 'translationToggle',
    initialState,
    reducers: {
        toggleKeys: (state) => {
            state.showKeys = !state.showKeys;
        },
        setKeys: (state, action: PayloadAction<boolean>) => {
            state.showKeys = action.payload;
        },
    },
});

export const {toggleKeys, setKeys} = translationToggleSlice.actions;

export const selectShowKeys = (state: { translationToggle: TranslationToggleState }) =>
    state.translationToggle.showKeys;

export default translationToggleSlice.reducer;
